import { styled } from "@mui/material";

const StyledMaintenanceBanner = styled("div")({
    backgroundColor: "#233A47",
    color: "#fff",
    padding: "10px",
    textAlign: "center",
    fontSize: "14px",
    fontWeight: "bold",
    border: "1px solid #2C99D2",
    width: "98%",
    marginLeft: "0.1vw",
});

const MaintenanceBanner = ({ showBanner }) =>
    showBanner && (
        <StyledMaintenanceBanner>
            KMConnect will be undergoing maintenance and unavailable from 9 p.m. to 11 p.m. PST on April 30 2026
        </StyledMaintenanceBanner>
    );

export default MaintenanceBanner;
